import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { Profile } from 'src/app/shared/models/security/profile';
import { saveAs } from 'file-saver';
import { PARAM_LABEL_BENEFICIAIRE, PARAM_LABEL_USER } from 'src/app/core/services/constant/constants.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import {
	CompetenceElementaireSESSAD,
	CompetenceSAAD,
	CompetenceSSIAD
} from 'src/app/shared/enums/competence.enum';
import { Subject, debounceTime, take } from 'rxjs';
import { LogService } from 'src/app/core/services/log/log.service';
import { ListingResponse } from 'src/app/shared/models/listing/listing-response';
import { RoleModalAjoutFormComponent } from '../modal/role-modal-ajout-form/role-modal-ajout-form.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-role',
	templateUrl: './list-role.component.html',
	styleUrls: ['./list-role.component.scss']
})
export class ListRolesComponent implements OnInit {
	roles: Profile[];
	currentPage = 1;

	sortType = 'lastName';
	sortOrder: SortOrder = 'asc';

	nextWeekNumber: number;
	competences: Record<string, string>;

	searchedInput = '';

	// nombre de page totale pour la pagination
	totalItems: number = 0;
	itemsPerPage = 10;

	role: Profile = null;
	isPlanif = false;
	labelRoleCapitalized: string;
	labelRolePluralized: string;

	ajoutRoleModalref: BsModalRef;

	isAddable = false;
	isImportable = false;
	isExportable = false;

	isMobile = false;
	screenWidth: number;

	isListingLoading: boolean = true;

	private searchSubject = new Subject<string>();

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {
		// ajout de délai à la saisie de recherche pour ne pas bombarder le back de requête
		this.searchSubject
			.pipe(
				debounceTime(300) // Délai en millisecondes
			)
			.subscribe(() => {
				this.searchByInput();
			});
	}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.labelRoleCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_USER
			);
		this.labelRolePluralized =
			this.facade.dataStorageService.getLabelPluralized(
				PARAM_LABEL_USER
			);

		this.isExportable = false;
		this.isAddable = true;
		this.isImportable = false;

		this.getRolesMinimal();
	}

	getRolesMinimal(): void {
		this.isListingLoading = true;
		this.facade.profileService.getRolesMinimal()
			.subscribe({
				next: (val) => {
					this.roles = val;
					this.totalItems = this.roles.length >= 8 ? 10 : 8;
				},
				error: (err: ErrorResponse) => {
					this.logger.error(err + '');
				},
				complete: () => {
					this.isListingLoading = false;
				}
			});
	}

	selectRole(role: Profile): void {
		const link = ['/gestion/roles', role.id];
		this.router.navigate(link);
	}

	/**
	 * Fonction pour les paramètres de trie. Si le string choisi vaut le string courant l'on change l'ordre de trie (croissant/décroissant)
	 * sinon l'on chance la colonne de trie et l'on trie par ordre crosisant
	 * @param str colonne de trie
	 */
	sortChange(str: string): void {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	onKeyUp() {
		this.searchSubject.next(this.searchedInput);
	}

	searchByInput() {
		this.currentPage = 1;
		this.getRolesMinimal();
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		// const initialState = {
		// 	serviceCenter: this.role.employee.serviceCenter
		// };
		// if (this.role === null || this.role.employee.serviceCenter === null) {
		// 	this.facade.toastService.createErrorToast(
		// 		"Vous n'êtes pas rattaché à un centre."
		// 	);
		// } else {
			this.ajoutRoleModalref = this.modalService.show(
				RoleModalAjoutFormComponent,
				{
					class: 'modal-lg',
					//initialState,
					backdrop: 'static'
				}
			);
			this.ajoutRoleModalref.content.updateListing
				.pipe(take(1))
				.subscribe((addedRole: Profile) => {
					this.roles.push(addedRole);
				});
		//}
	}

	pageHasChanged(pageNumber: any) {
		this.currentPage = pageNumber;

		this.getRolesMinimal();
	}
}
